import React, { useState } from 'react';
import { Import } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * ImportDeckDialog - Dialog for importing deck codes
 * shadcn/ui version
 */
export default function ImportDeckDialogShadcn({
  open,
  onOpenChange,
  onImport,
}) {
  const { t } = useLanguage();
  const [importCode, setImportCode] = useState('');

  const handleImport = () => {
    if (importCode.trim()) {
      onImport(importCode.trim());
      setImportCode('');
      onOpenChange(false);
    }
  };

  const handleOpenChange = (isOpen) => {
    onOpenChange(isOpen);
    if (!isOpen) {
      setImportCode('');
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {t('controls.importDeckCode', 'Import Deck Code')}
          </DialogTitle>
          <DialogDescription>
            {t('deck.import.instructions', 'Paste your deck code below to import your deck.')}
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <textarea
            className="w-full min-h-[120px] rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 resize-y"
            value={importCode}
            onChange={(e) => setImportCode(e.target.value)}
            placeholder={t('deck.import.placeholder', 'Paste your deck code here...')}
          />
        </div>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={() => handleOpenChange(false)}>
            {t('common.cancel', 'Cancel')}
          </Button>
          <Button
            onClick={handleImport}
            disabled={!importCode.trim()}
          >
            <Import className="h-4 w-4 mr-2" />
            {t('deck.import.importButton', 'Load Deck')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
